var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ma-5 pa-5"},[_c('rollGenerate')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }